import team from './team.en.ts'
import unit from './unit.en.ts'
import building from './building.en.ts'
import common from 'plugins/i18n/common.en.ts'
import reportStatusEn from 'plugins/i18n/entity/reportStatus.en.ts'

const report = {
	name: 'Report | Reports',
	icon: 'fas fa-ticket',
	fields: {
		id: common.id,
		report_status: {
			name: 'Status',
			...reportStatusEn.fields,
		},
		assigned_team: {
			...team.fields,
		},
		author: 'Reporter',
		type: 'Type',
		location: 'Location',
		building: {
			name: building.name,
			...building.fields,
		},
		unit: {
			name: unit.name,
			...unit.fields,
		},
		created: common.createdAt,
	},
}

export default report
